import { useEffect } from "react";
import PropTypes from "prop-types";
import { useFormState } from "react-final-form";

import FormSection from "../../common/FormSection";
import RadioGroup from "../../common/RadioGroup";
import Question from "../../common/Question";
import RadioButton from "../../common/RadioButton";
import FieldError from "../../common/FieldError";
import ProgressIndicator from "../../common/ProgressIndicator";
import { required } from "../../common/validation";

const TransportQuestion = () => {
  const stateApi = useFormState();

  const { values, submitFailed, errors, touched } = stateApi;

  const error = (submitFailed || touched?.difficultToUsePublicTransport)
    ? errors?.difficultToUsePublicTransport
    : null;

  useEffect(() => {
    if (values?.difficultToUsePublicTransport === "no" && typeof window !== "undefined") {
      // redirect if user selects "No" (useEffect to avoid side-effects during render)
      window.location.replace("/registration/dontneedtoregister");
    }
  }, [values?.difficultToUsePublicTransport]);

  return (
    <FormSection>
      <ProgressIndicator
        sectionPosition="Section 1 of 3"
        sectionName={"About you"}
      />
      <Question text={"Do you find it difficult to use public transport?"} />
      <p id="transport-help">
        For example, if you cannot get on a bus or travel comfortably when you are on board.
      </p>
      <RadioGroup error={error} aria-describedby="transport-help">
        <FieldError text={error} />
        <RadioButton
          label="Yes"
          validation={required}
          value="yes"
          fieldName="difficultToUsePublicTransport"
        />
        <RadioButton
          label="No"
          validation={required}
          value="no"
          fieldName="difficultToUsePublicTransport"
        />
      </RadioGroup>
    </FormSection>
  );
};

TransportQuestion.propTypes = {
  setDifficultToUseTransport: PropTypes.func,
};

TransportQuestion.defaultProps = {
  setDifficultToUseTransport: () => {},
};

export default TransportQuestion;
